import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'at-badge',
  templateUrl: './badges.component.html',
  styleUrls: ['./badges.component.scss']
})
export class BadgesComponent implements OnInit {

	@Input() theme: string;
  @Input() content: string;

  constructor() { }

  ngOnInit() {
  }

}
